import {
  PapiDaSharedCorebadgeAvailableBadges,
  PapiBadge,
  PapiUser,
  PapiComment,
} from '@wix/da-papi-types';
import { ResourceType } from '../types/resource';
import { NotificationType, NotificationQueueItem } from '../Notifications';

export enum CoreBadgeType {
  GLASS = 'glass',
  EMERALD = 'emerald',
  DIAMOND = 'diamond',
  HYPE = 'TheHype',
}

export enum AwardBadgeSource {
  THUMB_OVERLAY = 'thumb_overlay',
  THUMB_INFO = 'thumb_info',
  ACTIONBAR_MORE = 'actionbar_more',
  ACTIONBAR_BUTTON = 'actionbar_button',
  COMMENT = 'comment',
  PREVIEW = 'preview',
}

export interface CoreBadgeRecipient {
  user: PapiUser;
  typeId: ResourceType;
  itemId: number;
  // this is not great. the comment state organization is a pain and is hard to hook up to inside a saga
  comment?: PapiComment;
}

export type AwardableBadge = PapiDaSharedCorebadgeAvailableBadges['results'][0];
export type GemRestrictions =
  PapiDaSharedCorebadgeAvailableBadges['gemRestrictions'];

export interface CoreBadgeStateSlice {
  awardableBadges?: {
    [key in number]: {
      isLoading: boolean;
      results: AwardableBadge[];
    };
  };
  gemRestrictions?: GemRestrictions;
  isAwarding?: boolean;
  errorMsg?: string;
}

export interface BadgeNotification extends NotificationQueueItem {
  type: NotificationType.Badge;
  params: BadgeNotificationParams;
}

export interface BadgeNotificationParams {
  badge: PapiBadge;
  recipient: CoreBadgeRecipient;
  source: AwardBadgeSource;
}
